<template>
  <div>
    <v-navigation-drawer temporary v-model="sideNav" fixed width="230" app>
      <v-list>
        <v-list-tile
          v-for="items in this.menuItem"
          :key="items.title"
          router-link
          :to="items.link"
          @click="verClick(items.title)"
          exact
        >
          <v-list-tile-action>
            <v-icon left>{{items.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{items.title}}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar dark class="primary" app fixed>
      <!-- <v-toolbar-side-icon @click="sideNav = !sideNav" class="hidden-md-and-up"></v-toolbar-side-icon> -->
      <v-toolbar-title>
        <router-link to tag="span" style="cursor:pointer">
          <img
            :src="logo"
            @click="$router.currentRoute.path.includes('jogo')? $router.go(-1) : $router.push('/')"
            class="logo"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-md-and-up">
        <v-btn
          flat
          icon
          v-for="items in menuItem"
          :key="items.title"
          :to="items.link"
          exact
          @click="verClick(items.title)"
        >
          <v-icon>{{items.icon}}</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <!-- <v-flex xs2>
        </v-flex>-->
        <change-language></change-language>
        <v-btn
          flat
          v-for="items in menuItem"
          :key="items.title"
          router-link
          :to="items.link"
          exact
          @click="verClick(items.title)"
        >
          <v-icon left>{{items.icon}}</v-icon>
          {{items.title}}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import logoFootie from "../../assets/logoFootie.png";
import { mapActions } from "vuex";
import { mapState } from "vuex";
import ChangeLanguage from "./change_language";

export default {
  components: {
    ChangeLanguage
  },
  data() {
    return {
      sideNav: false,
      e1: 0,
      logo: logoFootie
    };
  },

  methods: {
    verClick(title) {
      if (title == "Perfil") {
        console.log("clicou no perfil, ");
        console.log("" + this.$auth.check());
        this.showOneUser(this.$auth.user());
      }
      if (title == this.$t("logout")) {
        this.$auth.logout();
      }
    },
    ...mapActions({
      showOneQuestion: "Questions/showOneQuestion",
      showOneUser: "Users/showOneUser"
    })
  },
  computed: {
    menuItem() {
      if (this.$auth.check()) {
        let menu = [
          {
            icon: "fa-trophy",
            title: this.$t("championships"),
            link: "/campeonatos"
          },
          {
            icon: "add_circle",
            title: this.$t("create_championship"),
            link: "/campeonatos/novo"
          },
          // {icon: 'person', title: this.$t('profile'), link: '/perfil'},
          {
            icon: "fas fa-sign-out-alt",
            title: this.$t("logout"),
            link: "/logout"
          }
        ];
        return menu;
      } else {
        let menu = [
          {
            icon: "fa-trophy",
            title: this.$t("championships"),
            link: "/campeonatos"
          },
          { icon: "touch_app", title: this.$t("login"), link: "/login" }
          // {icon: 'fa-user', title: this.$t('register'), link: "/register"}
        ];
        return menu;
      }
    },
    change_language() {}
  }
};
</script>

<style scoped>
.logo {
  width: 80px !important;
  height: auto;
  margin-top: 10px;
}
</style>

